<!-- MEUS ATENDIMENTOS (PÓS ATENDIMENTO)-->

<template>
    <v-card class="dialog" color="grey lighten-3" height="1080px">
        <v-toolbar dark color="#FE7975">
            <v-btn icon dark @click="$emit('fechar')">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            
            <v-toolbar-title>Meus Atendimentos</v-toolbar-title>
        </v-toolbar>

        <v-row v-if="!isExibirAtendimento" :class="isExibirAtendimento?'animated fadeOut': 'animated fadeIn'">
            <v-col cols="12">
                <v-layout justify-center>
                    <v-card flat class="mt-1" max-width="700px" color="grey lighten-3" elevation="3">
                    <v-progress-linear color="orange" v-if="load" :indeterminate="true" />
                    <v-date-picker
                        :disabled="load"
                        v-model="date"
                        full-width
                        header-color="blue"
                        locale="pt-Br">
                    </v-date-picker>
                </v-card>
                </v-layout>
            </v-col>
        </v-row>
        <v-row v-if="!isExibirAtendimento" :class="isExibirAtendimento?'animated fadeOut': 'animated fadeIn'">
            <v-layout justify-center>
                <v-card width="700px">
                  <v-card-title dense class="mb-0 mt-0">
                    <v-spacer/>
                    <v-text-field v-model="search" label="Buscar Paciente" append-icon="search"></v-text-field>
                  </v-card-title>
                  <v-divider/>
                    <v-progress-linear color="orange" v-show="load" :indeterminate="true" />
                    <v-card v-if="load" color="grey lighten-4" width="700px">
                      <v-list v-for="i in 4" :key="i">
                        <v-skeleton-loader type="list-item"/>
                        <v-divider/>
                      </v-list>
                    </v-card>
                    <v-list-item v-if="!load && consultas.length == 0">
                      <v-list-item-title>
                            Não foram encontrados atendimentos para esta data
                      </v-list-item-title>
                    </v-list-item>
                    <v-virtual-scroll
                        v-if="!load"
                        :class="load?'animated fadeIn':''"
                        :bench="0"
                        :items="consultasFiltradas"
                        height="250"
                        item-height="60"
                    >
                        <template v-slot:default="{ item }">
                            <v-list-item :key="item.os" :disabled="load" @click="isExibirAtendimento = true, currentSelected = item">
                              <v-list-item-content>
                                <v-list-item-title>
                                    <strong>{{ item.nomePaciente }}</strong>
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                  <b>OS: </b>{{item.os}} <b>ID Paciente:</b> {{ item.idPaciente }}  <b>Data de nascimento:</b> {{ formatarData(item.dataNascimento) }}
                                </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                  <v-spacer/>
                                  <v-btn icon>
                                    <v-icon small color="primary">
                                      mdi-open-in-new
                                    </v-icon>
                                  </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                            <v-divider></v-divider>
                        </template>
                </v-virtual-scroll>
                </v-card>
            </v-layout>
        </v-row>

        <v-row>
          <v-layout justify-center>
            <v-card flat color="grey lighten-3" v-if="isExibirAtendimento" :class="isExibirAtendimento?'animated fadeIn': 'animated fadeOut'" class="mt-4">
              <historico :ficha="currentSelected" :isProntuario="false" @voltar="isExibirAtendimento = false"/>
            </v-card>
          </v-layout>
        </v-row>
    </v-card>
</template>
<script>
import medicoService from '../../services/medico.service'
import historico from '../medico/historico.vue'
import moment from 'moment'

export default {
  components: {
    historico
  },
  data: () => ({
    user: '',
    load: false,
    dialog: false,
    date: null,
    consultas: [],
    isExibirAtendimento: false,
    currentSelected: '',
    search: ''
  }),
  mounted () {
    this.user = this.$store.getters.usuario
    this.carregarDataAtual()
    this.buscarPacientesConsultasPorData()
  },
  methods: {
    formatarData (data) {
      return moment(data).format('DD/MM/YYYY')
    },
    carregarDataAtual () {
      var now = new Date()
      var year = now.getFullYear()
      var month = String(now.getMonth() + 1).padStart(2, '0')
      var day = String(now.getDate()).padStart(2, '0')
      this.date = `${year}-${month}-${day}`
      console.log('antes de chamar')
    },
    buscarPacientesConsultasPorData () {
      this.load = true
      medicoService.medico.buscarPacientesConsultasPorData(this.user.id, this.date).then(r => {
        if (r.status == 200) {
          // console.log('VEIO ', r.data)
          this.consultas = r.data
        } else {
          console.log('NAO VEIO')
        }
      }).finally(() => {
        this.load = false
      })
    }
  },
  computed: {
    consultasFiltradas () {
      if (!this.search) {
        console.log('aaaa')
        return this.consultas
      }
      const busca = this.search.toLowerCase()
      return this.consultas.filter(item => {
        const nome = item.nomePaciente.toLowerCase()
        return nome.includes(busca)
      })
    }
  },
  watch: {
    date (val) {
      if (val != null) {
        this.buscarPacientesConsultasPorData()
      } else {
      }
    }
  }
}
</script>
<style scoped>
</style>
